<template>
  <div class="grading-fullscreen">
    <ExamGrading 
      v-if="formKey"
      :form-key="formKey"
      :initial-answer-key="answerKey"
      :phase="phase"
      :exam-form="examForm"
      :wave-id="waveId"
      @back="handleBack"
    />
    <div v-else class="loading-tip">
      <p>参数错误，请返回</p>
      <el-button @click="handleBack">返回</el-button>
    </div>
  </div>
</template>

<script>
import ExamGrading from './ExamGrading.vue'

export default {
  name: 'GradingPage',
  components: { ExamGrading },
  
  computed: {
    formKey() {
      return this.$route.query.key || ''
    },
    answerKey() {
      return this.$route.query.answerKey || null
    },
    phase() {
      return parseInt(this.$route.query.phase) || 0
    },
    examForm() {
      return parseInt(this.$route.query.examForm) || 0
    },
    waveId() {
      return parseInt(this.$route.query.waveId) || 0
    }
  },
  
  methods: {
    handleBack() {
      // 返回上一页
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push('/project')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.grading-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background: #f5f7fa;
}

.loading-tip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #909399;
}
</style>
